import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const usePromotionsCardStyles = makeStyles({
    root: {
        marginTop: tokens.spacingVerticalS
    },
    promoSectionRoot: {
        marginTop: tokens.spacingVerticalS
    },
    contentWrapper: {
        marginTop: tokens.spacingVerticalS,
        backgroundColor: tokens.colorBrandBackgroundStatic,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        height: '100px',
        paddingLeft: tokens.spacingHorizontalXXL,
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: '.8fr 1fr'
    },
    promoTitle: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold
    },
    subTitle: {
        fontSize: tokens.fontSizeBase300
    },
    description: {
        fontSize: tokens.fontSizeBase200
    },
    amountDueValues: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr .25fr',
        justifyItems: 'center',

        '@media screen and (max-width: 780px)': {
            gridTemplateColumns: '1fr 1fr'
        }
    },
    discountAmount: {
        color: 'green',
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold
    },
    valueWrapper: {},
    valueSubtext: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralStroke1
    },
    title: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold,
        lineHeight: tokens.lineHeightBase500
    }
});

export default usePromotionsCardStyles;
